<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-warning"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div>
    <ul class="fa-ul">
      <li *ngFor="let message of messages"><i class="fa-li fa icon-warning"></i>{{message}}</li>
    </ul>

    <p>{{confirmationMessage}}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionConfirmed($event)"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
